module.exports = {
	"pagination": {
		"DescribeDBEngineVersions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBEngineVersions"
		},
		"DescribeDBInstances": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBInstances"
		},
		"DescribeDBParameterGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBParameterGroups"
		},
		"DescribeDBParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Parameters"
		},
		"DescribeDBSecurityGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSecurityGroups"
		},
		"DescribeDBSnapshots": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSnapshots"
		},
		"DescribeDBSubnetGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSubnetGroups"
		},
		"DescribeEngineDefaultParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "EngineDefaults.Marker",
			"result_key": "EngineDefaults.Parameters"
		},
		"DescribeEventSubscriptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "EventSubscriptionsList"
		},
		"DescribeEvents": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Events"
		},
		"DescribeOptionGroupOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OptionGroupOptions"
		},
		"DescribeOptionGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OptionGroupsList"
		},
		"DescribeOrderableDBInstanceOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OrderableDBInstanceOptions"
		},
		"DescribeReservedDBInstances": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedDBInstances"
		},
		"DescribeReservedDBInstancesOfferings": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedDBInstancesOfferings"
		},
		"ListTagsForResource": {
			"result_key": "TagList"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/rds-2013-01-10.paginators.json
// module id = 666
// module chunks = 0